<template>
  <div class="container" id="skills">
    <div class="skills-box">
      <div class="skills-text">
        <a href="https://github.com/SmileyDoodle" target="_blank"
          ><i class="icon fas fa-code fa-3x"></i>
          <h2>GitHub</h2></a
        >
        <p>
          I have experience in working with Vue, JavaScript (ES6), TypeScript,
          PHP, Laravel, SQL, MongoDB, Docker, Git, Cypress, Unit test,
          Bootstrap, Tailwind, Bulma, etc.
        </p>
      </div>
      <div class="skills-text">
        <router-link to="/design"
          ><i class="icon fas fa-paint-brush fa-3x"></i>
          <h2>Design</h2></router-link
        >
        <p>
          Here you can find my featured works related to graphic and web design.
          I use such tools like Procreate, Affinity Trinity, Adobe products,
          etc.
        </p>
      </div>
      <div class="skills-text">
        <router-link to="/blogging"
          ><i class="icon far fa-comment fa-3x"></i>
          <h2>Blogging</h2></router-link
        >
        <p>
          I enjoy listening to interesting stories, but what’s more, I enjoy
          telling them. Here you can find my blog posts, and, hopefully, learn
          something new for yourself.
        </p>
      </div>
    </div>
    <div class="skills-box">
      <div class="skills-text">
        <router-link to="/photography"
          ><i class="icon fas fa-camera fa-3x"></i>
          <h2>Photography</h2></router-link
        >
        <p>
          Sometimes you need to freeze a moment in order to be reminded how
          beautiful the world is. Photography is my way to do it.
        </p>
      </div>
      <div class="skills-text">
        <router-link to="/video-editing"
          ><i class="icon fas fa-film fa-3x"></i>
          <h2>Video Editing</h2></router-link
        >
        <p>
          My interest for storytelling and photography developed into video
          editing passion. Here you can check out my works.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Skills",
};
</script>

<style>
#skills {
  padding: 120px 0 10px;
}
.skills-box {
  position: relative;
  display: inline-block;
  padding: 50px 0;
}
.skills-text {
  position: relative;
  display: inline-block;
  width: 28%;
  margin: 0 1.8rem;
  opacity: 0.7;
  transition: all 0.5s ease-in;
}
.skills-text:hover {
  opacity: 1;
  transition: all 0.5s ease-in;
}
#skills h2 {
  color: #f3a822;
  padding: 2rem 0 1rem;
  cursor: pointer;
}
.icon {
  color: #085561;
  transition: all 0.5s ease-in;
}
.icon:hover {
  color: #f3a822;
  transition: all 0.5s ease-in;
  cursor: pointer;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .skills-text {
    width: 60%;
    padding-bottom: 3.5rem;
  }
  .skills-box {
    padding: 0 0;
  }
}
@media only screen and (max-width: 600px) {
  #skills {
    padding-top: 70px;
  }
  .skills-box {
    padding: 0 0;
  }
  .skills-text {
    width: 65%;
    padding-bottom: 3.5rem;
  }
  #skills h2 {
    font-size: 1.7rem;
    padding: 1rem 0 0.5rem;
  }
}
</style>
